<template>

    <Panel>

        <PanelHeader heading="Confirm" subheading="Final check and save the sale" />

        <PanelBody>

            <div>
                <dl class="divide-y divide-gray-100">
                    <div class="px-0 py-6 sm:grid sm:grid-cols-3 sm:gap-4">
                        <dt class="text-sm font-medium text-gray-900">Sale name</dt>
                        <dd class="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">{{ sale?.name || '–' }}</dd>
                    </div>
                    <div class="px-0 py-6 sm:grid sm:grid-cols-3 sm:gap-4">
                        <dt class="text-sm font-medium text-gray-900">Sale type</dt>
                        <dd class="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">{{ sale?.sale_type?.name || '–' }}</dd>
                    </div>
                    <div class="px-0 py-6 sm:grid sm:grid-cols-3 sm:gap-4">
                        <dt class="text-sm font-medium text-gray-900">Auctioneer</dt>
                        <dd class="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">{{ sale_organisation?.organisation_name || '–' }}</dd>
                    </div>
                    <div class="px-0 py-6 sm:grid sm:grid-cols-3 sm:gap-4">
                        <dt class="text-sm font-medium text-gray-900">Description</dt>
                        <dd class="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0" v-html="sale?.description || '–'"></dd>
                    </div>
                    <div class="px-0 py-6 sm:grid sm:grid-cols-3 sm:gap-4">
                        <dt class="text-sm font-medium text-gray-900">Detailed Information</dt>
                        <dd class="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">{{ sale?.detailed_info || '–' }}</dd>
                    </div>
                    <div class="px-0 py-6 sm:grid sm:grid-cols-3 sm:gap-4">
                        <dt class="text-sm font-medium text-gray-900">Format</dt>
                        <dd class="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0"><span>{{ sale.format }}</span> <span v-if="sale.format == 'online'">({{ sale.bidding_platform }})</span></dd>
                    </div>
                    <div class="px-0 py-6 sm:grid sm:grid-cols-3 sm:gap-4">
                        <dt class="text-sm font-medium text-gray-900">Sale starts</dt>
                        <dd class="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">
                            <div class="px-0 sm:grid sm:grid-cols-2 sm:gap-4">
                                <div class="mt-1 text-sm leading-6 text-gray-700 col-span-1 sm:mt-0">
                                    <p>
                                        <strong class="block w-full text-sm font-medium text-gray-900">Date</strong>
                                        <time>{{ moment(sale.starts_at_date).format(CONFIG.dates.formats.full_date) }}</time>
                                    </p>
                                </div>
                                <div class="mt-1 text-sm leading-6 text-gray-700 col-span-1 sm:mt-0">
                                    <p>
                                        <strong class="block w-full text-sm font-medium text-gray-900">Time</strong>
                                        <time>{{ moment(sale.starts_at_date+' '+sale.starts_at_time).format(CONFIG.dates.formats.full_time) }}</time>
                                    </p>
                                </div>
                            </div>
                        </dd>
                    </div>
                    <div class="px-0 py-6 sm:grid sm:grid-cols-3 sm:gap-4">
                        <dt class="text-sm font-medium text-gray-900">Sale ends</dt>
                        <dd class="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">
                            <div class="px-0 sm:grid sm:grid-cols-2 sm:gap-4">
                                <div class="mt-1 text-sm leading-6 text-gray-700 col-span-1 sm:mt-0">
                                    <p>
                                        <strong class="block w-full text-sm font-medium text-gray-900">Date</strong>
                                        <time>{{ moment(sale.ends_at_date).format(CONFIG.dates.formats.full_date) }}</time>
                                    </p>
                                </div>
                                <div class="mt-1 text-sm leading-6 text-gray-700 col-span-1 sm:mt-0">
                                    <p>
                                        <strong class="block w-full text-sm font-medium text-gray-900">Time</strong>
                                        <time>{{ moment(sale.ends_at_date+' '+sale.ends_at_time).format(CONFIG.dates.formats.full_time) }}</time>
                                    </p>
                                </div>
                            </div>
                        </dd>
                    </div>
                    <div v-if="sale.format === 'online'" class="px-0 py-6 sm:grid sm:grid-cols-3 sm:gap-4">
                        <dt class="text-sm font-medium text-gray-900">First lots end</dt>
                        <dd class="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">
                            <div class="px-0 sm:grid sm:grid-cols-2 sm:gap-4">
                                <div class="mt-1 text-sm leading-6 text-gray-700 col-span-1 sm:mt-0">
                                    <p>
                                        <strong class="block w-full text-sm font-medium text-gray-900">Date</strong>
                                        <time>{{ moment(sale.first_lots_end_date).format(CONFIG.dates.formats.full_date) }}</time>
                                    </p>
                                </div>
                                <div class="mt-1 text-sm leading-6 text-gray-700 col-span-1 sm:mt-0">
                                    <p>
                                        <strong class="block w-full text-sm font-medium text-gray-900">Time</strong>
                                        <time>{{ moment(sale.first_lots_end_date+' '+sale.first_lots_end_time).format(CONFIG.dates.formats.full_time) }}</time>
                                    </p>
                                </div>
                            </div>
                        </dd>
                    </div>
                    <div class="px-0 py-6 sm:grid sm:grid-cols-3 sm:gap-4">
                        <dt class="text-sm font-medium text-gray-900">Sale repeats</dt>
                        <dd v-if="sale.recurring_sale" class="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">{{ `${sale.repeat_frequency} up to ${moment(sale.repeat_up_to).format('ddd Do MMM \'YY')}` }}</dd>
                        <dd v-else class="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">Never</dd>
                    </div>
                    <div class="px-0 py-6 sm:grid sm:grid-cols-3 sm:gap-4">
                        <dt class="text-sm font-medium text-gray-900">Entries invited?</dt>
                        <dd class="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">{{ sale.entries_invited ? 'Yes' : 'No' }}</dd>
                    </div>
                    <div v-if="sale.entries_invited_number_before && sale.entries_invited_unit_before" class="px-0 py-6 sm:grid sm:grid-cols-3 sm:gap-4">
                        <dt class="text-sm font-medium text-gray-900">Entries open</dt>
                        <dd class="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">{{ `${sale.entries_invited_number_before} ${sale.entries_invited_unit_before} before sale begins` }}</dd>
                    </div>
                    <div class="px-0 py-6 sm:grid sm:grid-cols-3 sm:gap-4">
                        <dt class="text-sm font-medium text-gray-900">Entries close</dt>
                        <dd class="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">{{ `${sale.entries_close_number_before} ${sale.entries_close_unit_before} before sale begins` }}</dd>
                    </div>

                    <div class="px-0 py-6 sm:grid sm:grid-cols-3 sm:gap-4">
                        <dt class="text-sm font-medium text-gray-900">Complete payment required by</dt>
                        <dd class="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">{{ `${sale.final_payment_number_after} ${sale.final_payment_unit_after} after sale ends` }}</dd>
                    </div>
                    <div class="px-0 py-6 sm:grid sm:grid-cols-3 sm:gap-4">
                        <dt class="text-sm font-medium text-gray-900">Collection required by</dt>
                        <dd class="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">{{ `${sale.final_collection_number_after} ${sale.final_collection_unit_after} after sale ends` }}</dd>
                    </div>
                </dl>
            </div>

        </PanelBody>

        <PanelFooter>
            <Button type="button" width="w-auto" class="ml-2" :onClick="() => activate()">Save</Button>
        </PanelFooter>

    </Panel>

</template>

<script>
import { useSaleStore } from '@sto/sale.store'
import { useSystemStore } from '@sto/system.store'
import { useAuthStore } from '@sto/auth.store'
import { computed, onMounted, onBeforeMount, reactive, watch } from 'vue'
import { isValid, getPayload, getUserOrganisationType } from '@lib/helpers'
import { useRoute, useRouter } from 'vue-router'
import CONFIG from '@lib/config'
import LoadingIcon from '@ico/LoadingIcon.vue'
import Fieldset from '../../globals/Fieldset.vue'
import moment from 'moment'
export default {
    components: {
        LoadingIcon
    },
    setup() {
        const ROUTE = useRoute()
        const ROUTER = useRouter()
        const SALE_STORE = useSaleStore()
        const SYSTEM_STORE = useSystemStore()
        const AUTH_STORE = useAuthStore()

        const sale = computed(() => SALE_STORE.sale)

        const sale_organisation = computed(() => {
            return AUTH_STORE.user.organisation_auctioneers.find((a) => a.id == sale.value.auctioneer_id)
        })
        
        const activate = async () => {
            
            try {
                const activate = await SALE_STORE.activate(sale.value.id)
                SYSTEM_STORE.addSuccess('Success!','Your sale has been saved')
                ROUTER.push({name: 'sales.index'})
            } catch (error) {
                console.error('activate error', error)
                SYSTEM_STORE.addError('Whoops!',error?.message || 'There was and error saving your sale')
            }
        }

        return {
            sale,
            sale_organisation,
            activate,
            moment,
            CONFIG
        }
    }
}

</script>

